import { Component, OnInit } from '@angular/core';
import { ProductService } from "../services/product/product.service";

@Component({
  selector: 'app-robimeds',
  templateUrl: './robimeds.component.html',
  styleUrls: ['./robimeds.component.css']
})
export class RobimedsComponent implements OnInit {
  productsByMarque = [];
  pageSize = 12;
  page;
  total;
  constructor(private productService:ProductService) { }

  ngOnInit(): void {
    this.productService.getProductByMarque(104).subscribe(res => {
      this.productsByMarque = res['products'];
      console.log('this.productsByMarque',  this.productsByMarque);
    })
  }

  changeMax(nbrProducts)
  {
    this.pageSize = nbrProducts;
  }

}
